export const Servicos = [
  {
    id: 'servico1',
    nome: 'Serviço 1',
    duracaoMin: 50,
    valor: 'A combinar',
  },
  {
    id: 'servico2',
    nome: 'Serviço 2',
    descricao: 'Descrição do serviço 2',
    duracaoMin: 25,
    valor: 'A combinar',
  },
  {
    id: 'servico3',
    nome: 'Serviço 3',
    duracaoMin: 40,
    valor: 'A combinar',
  },
]

export const DisponibilidadeMock = {
  '2026-06-30': ['09:00', '11:00', '14:00'],
  '2026-07-01': [],
  '2026-07-02': ['08:00', '10:00', '14:00', '16:00'],
  '2026-07-03': ['09:00', '13:00', '15:30'],
  '2026-07-04': ['08:30', '11:00', '14:00'],
}
